module.exports = __webpack_public_path__ + "img/female.4de1f4db.svg";